import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";

import { enum_api_uri } from "common/hooks/utils/enum";
// import { useAuthStore } from "user/store/useAuthStore";

interface SignupRequest {
    customer_idx: number | null;
    customer_name: string | null;
    m_category: number;
    m_email: string;
    m_name: string;
    m_mobile: string;
    m_password: string;
}

interface SignupResponse {
    data: null;
}

export const usePostSignup = (successCallback?: () => void): UseMutationResult<SignupResponse, Error, SignupRequest, unknown> => {
    // const setAuth = useAuthStore(state => state.setAuth);

    return useMutation<SignupResponse, Error, SignupRequest>({
        mutationFn: async ({ customer_idx, customer_name, m_category, m_email, m_name, m_mobile, m_password }: SignupRequest) => {
            const response = await axios.post(enum_api_uri.user.signup, {
                customer_idx,
                customer_name,
                m_category,
                m_name,
                m_email,
                m_mobile,
                m_password,
            });
            return response.data;
        },
        onSuccess: data => {
            successCallback?.();
        },
    });
};
